import { TextField, InputAdornment } from "@mui/material";
import { PhoneIcon } from "@heroicons/react/24/outline";
import React, { useState, useEffect } from "react";

interface PhoneFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  required?: boolean;
  validate?: boolean; 
  showError?: boolean;
  disabled?: boolean;
}

const PhoneField: React.FC<PhoneFieldProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  required = false,
  validate = true,
  showError = true,
  disabled = false,
}) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

//   const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
//     const modifiedEvent = {
//       ...e,
//       target: {
//         ...e.target,
//         value: digitsOnly,
//       },
//     };
//     onChange(modifiedEvent as React.ChangeEvent<HTMLInputElement>);
//   };

const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only digits, max 10
    let digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
    
    // If first digit is entered, validate it's a valid Indian mobile prefix (6, 7, 8, or 9)
    if (digitsOnly.length > 0) {
      const firstDigit = digitsOnly[0];
      if (!/^[6-9]$/.test(firstDigit)) {
        // Invalid first digit - don't accept it, return previous value
        return;
      }
    }
  
    onChange({
        target: {
          name: name,
          value: digitsOnly,
        },
      } as React.ChangeEvent<HTMLInputElement>);
  };
  

  useEffect(() => {
    if (!validate) return;

    if (!value) {
      setError(required);
      setHelperText(required ? "Mobile number is required" : "");
    } else if (value.length !== 10) {
      setError(true);
      setHelperText("Indian mobile number must be exactly 10 digits");
    } else if (!/^[6-9]\d{9}$/.test(value)) {
      setError(true);
      setHelperText("Invalid Indian mobile number. Must start with 6, 7, 8, or 9");
    } else {
      setError(false);
      setHelperText("");
    }
  }, [value, required, validate]);

  return (
    <TextField
      fullWidth
      required={required}
      name={name}
      label={label}
      type="tel"
      value={value}
      onChange={handleInput}
      onBlur={onBlur}
      disabled={disabled}
      error={showError && error}
      helperText={showError && error ? helperText : ""}
      inputProps={{ 
        maxLength: 10,
        inputMode: 'numeric',
        pattern: '[6-9][0-9]{9}',
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PhoneIcon className="h-5 w-5 text-gray-500" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PhoneField;
